const $$splitComponentImporter = () => import('/Users/xpress/Code/knrt/jgxt/projects/jgxt/ui/web/src/routes/console/_auth/_layout/patient/$accountId_.diet.$metricId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { type MonitorFoodItem, type MonitorRecordDetail } from '@/api/patient-monitor';
export const Route = createFileRoute('/console/_auth/_layout/patient/$accountId_/diet/$metricId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});

// 与服务端 foodItemMaxCalories / foodItemMaxNutrient 同一上限，越界服务端会直接拒绝

// 草稿行：条目可增删，下标会移位，所以身份和「对应哪条 AI 原值」都要在挂载时定死
//
// 用下标现算会让删掉 A 之后 B 去跟 A 的原值比，名称、热量、营养素提示全部错行
type DraftRow = {
  // 条目可增删，下标会移位，身份要在挂载时定死
  key: string;
  food: MonitorFoodItem;
};

// 条目表格的列定义：key 为空表示名称/份量这类文本列，单独渲染

// 表单只在拿到详情后挂载，草稿用详情初始化一次即可，不必等数据回来再同步
//
// 页头标题与返回按钮由 ConsoleLayout 按路由提供（routeTitleRules / resolveBackTarget），
// 页面内不再画一层，否则会和布局页头叠成两行

// 左列：照片、备注与 AI 原始识别结果，全部只读，是医护判断该改什么的依据

// 一条目一行：列对齐后能纵向扫读，Tab 横向走一行，符合填表习惯

// 表格里的数字格
//
// 不用 SimpleNumberInput：它的 NumberField.Group 带加减按钮，在这里会吃掉七成列宽
// （实测输入框只剩 24px），而全手填是键入数值、不是逐步微调，那两个按钮没有价值。
// 保留本地字符串是为了让"0."这种中间态能继续输下去——直接受控成数字会把小数点吞掉
// endregion
// niceDomain 把上下界对齐到 1/2/5 系列的整齐步长，避免出现 38.7 这种刻度
// endregion
// endregion
// SwipeRow 仅对可删除行启用左滑露出删除按钮,其他行直接透传内容
// endregion
// AI 巡查风险等级 → 徽章文案与色调
// 随访状态 → 徽章文案与色调, 已取消的不会出现在首页
// 复查提醒与随访卡片的统计范围说明
// 用户来源分类与条形配色, 顺序即展示顺序; 平台是「无院内记录」的兜底类, 用中性灰
// 各指标的口径说明, 集中放一处便于核对
// endregion
// 管理视角: 超管额外看到管理归属、覆盖、活跃趋势与功能使用; 健管师 / 运营员只看基础概览
// 超管的核心指标: 用真实的活跃与新增替代原先写死的两项 100%
// region 复查提醒与患者随访
// 管理视角和医生工作台共用, 统计范围由服务端按角色决定, 卡片描述里写明
// 上面一排底色统计格, 下面是近 7 天的明细列表
// endregion
// 用户来源分布: 横向条形, 全为 0(含数据未就绪)时按无数据占位
// 指标行:仿模板 KPI 行;纯数字走 KPI.Value,带 % 等符号的直接文本渲染
// endregion
if (import.meta.hot) {
  import.meta.hot.accept(newModule => {
    if (newModule && newModule.Route && typeof newModule.Route.clone === 'function') {
      newModule.Route.clone(Route);
    }
  });
}